import { render, staticRenderFns } from "./ServicePromotions.vue?vue&type=template&id=660cf0a5"
import script from "./ServicePromotions.vue?vue&type=script&lang=js"
export * from "./ServicePromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports